import { lazy } from 'react';
var TRK00000 = lazy(function () { return import('view/Project/TRK/TRK00000/TRK00000_home'); });
var TRK00001 = lazy(function () { return import('view/Project/TRK/TRK00001/TRK00001_home'); });
var TRK00002 = lazy(function () { return import('view/Project/TRK/TRK00002/TRK00002_home'); });
var TRK_ROUTES = [
    { path: '/TRK00/TRK00000', component: TRK00000 },
    { path: '/TRK00/TRK00001', component: TRK00001 },
    { path: '/TRK00/TRK00002', component: TRK00002 },
];
export default TRK_ROUTES;
